import { render } from "./forgot_password_modal.vue?vue&type=template&id=133078d3&scoped=true"
import script from "./forgot_password_modal.vue?vue&type=script&lang=js"
export * from "./forgot_password_modal.vue?vue&type=script&lang=js"

import "./forgot_password_modal.vue?vue&type=style&index=0&id=133078d3&scoped=true&lang=css"

import exportComponent from "/home/denoh/project/in_client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-133078d3"]])

export default __exports__